import kitchenInstance from '../instance'

const deleteKitchenMonitorConfig = (id) => {
	return kitchenInstance.delete(`/kitchenMonitorConfigs/${id}`)
}

export default deleteKitchenMonitorConfig
